module.exports = __webpack_public_path__ + "static/media/shopify.6928c1ab.svg";